export default function Grid({ children, min = "240px", gap = "5", className = "" }) {
  return (
    <div
      className={className}
      style={{
        display: "grid",
        gap: `var(--s${gap})`,
        gridTemplateColumns: `repeat(auto-fill, minmax(min(${min}, 100%), 1fr))`,
      }}
    >
      {children}
    </div>
  );
}
